import { z } from 'zod';

export function GenericAssetSchema<
  TType extends z.ZodTypeAny,
  TCategory extends z.ZodTypeAny,
  TVersion extends z.ZodOptional<z.ZodTypeAny>,
  TData extends z.ZodTypeAny,
>(
  idAssetType: TType,
  idAssetCategory: TCategory,
  Version: TVersion,
  data: TData
) {
  return z.object({
    idAsset: z.number().int(),
    idAssetType, // <- literal
    idAssetCategory, // <- literal
    Version,
    name: z.string().optional(),
    data,
  });
}
